import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Always default to "light" mode when first connecting to the site
  const getInitialTheme = () => {
    // Clear any previously saved theme to ensure light mode is always the default
    // when first connecting to the site
    if (!localStorage.getItem('initial_theme_set')) {
      localStorage.setItem('theme', 'light');
      localStorage.setItem('initial_theme_set', 'true');
    }
    
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'light';
  };

  const [theme, setTheme] = useState(getInitialTheme);

  // Update the theme in localStorage and on the html element whenever it changes
  useEffect(() => {
    localStorage.setItem('theme', theme);
    
    // Apply theme to the document with standard pattern
    // When theme is 'dark', we add the dark class (showing dark theme)
    // When theme is 'light', we remove the dark class (showing light theme)
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
      document.documentElement.style.backgroundColor = '#111827';
      document.body.style.backgroundColor = '#111827';
    } else {
      document.documentElement.classList.remove('dark');
      document.documentElement.style.backgroundColor = '#ffffff';
      document.body.style.backgroundColor = '#ffffff';
    }

    // Force a repaint to ensure styles are applied
    document.body.style.display = 'none';
    setTimeout(() => {
      document.body.style.display = '';
    }, 5);
  }, [theme]);

  // Toggle theme function
  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light');
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
